module.exports = __webpack_public_path__ + "static/media/Deal-red.e2fa34aa.svg";